export default {
  kek: 'кек',
  or: 'или',
  cringe: 'кринж',
  tagline: 'Интернет решит.',
  twitchUrl: 'Ссылка на Twitch',
  start: 'Начать',
  error: 'Ошибка',
  warning: 'Внимание',
  chatConnected: 'Подключено к чату',
  chatError: 'Ошибка чата',
  rewardNotSelected:
    'Награда не выбрана — реакции на награды будут проигнорированы. Открой настройки и выбери награду.',
  rewardNotFound:
    'Выбранная награда больше не существует на канале. Открой настройки и выбери другую.',
  nameErr:
    'Кажется, твое имя введено неправильно. Введи имя канала или полную ссылку на него.',
  settings: {
    title: 'Настройки',
    tagline: 'Настрой стрим легко, весело и со вкусом.',
    video: 'Видео',
    addMethod: 'Способ добавления',
    bitsCount: 'Кол-во битсов',
    reward: 'Награда',
    selectReward: 'Выберите награду',
    duration: 'Длительность',
    mins: 'минут',
    viewCount: 'Мин. просмотров',
    queueSize: 'Размер очереди',
    banwordsFilter: 'Фильтр банвордов',
    enabled: 'Включен',
    platforms: 'Принимаемые платформы',
    acceptYoutube: 'Принимать видео с YouTube',
    acceptTiktok: 'Принимать видео с TikTok',
    acceptTwitch: 'Принимать клипы с Twitch',
    atLeastOnePlatform: 'Должна быть включена хотя бы одна платформа',
    selectMethod: 'Выберите способ',
    addMethodSimple: 'Простое сообщение',
    addMethodReward: 'Награда',
    addMethodBits: 'Битсы',
    skipCount: 'Голоса за пропуск',
    variants: 'Варианты',
    name: 'Название',
    triggers: 'Триггеры',
    skipModifier: 'Счетчик пропуска',
    color: 'Цвет',
    selectTrigger: 'Выберите или введите',
    addCustomVariant: 'Добавить свой вариант',
    autoSwitch: 'Автопереключение',
    run: 'Начать',
    other: 'Разное',
    clearStatistic: 'Очистить статистику',
    resetSettings: 'Сброс настроек',
    exportSettings: 'Экспорт настроек',
    importSettings: 'Импорт настроек',
    delete: 'Удалить',
    resetSettingsConfirm: 'Вы уверены, что хотите сбросить все настройки?',
    resetSettingsDone: 'Ваши настройки были успешно сброшены',
    clearStatisticConfirm: 'Вы уверены, что хотите очистить статистику?',
    clearStatisticDone: 'Статистика очищена',
    importSettingsDone: 'Настройки успешно импортированы',
    importSettingsError: 'Ошибка импорта настроек',
    yes: 'Да',
    no: 'Нет',
  },
  neutral: 'Это... ОК?',
  kekPrefix: 'ПОЛНЕЙШИЙ',
  cringePrefix: 'ЛЮТЕЙШИЙ',
  omegaPrefix: 'ОМЕГА',
  videoWait: 'Ожидаем появления видео',
  alreadyExistsVideo: 'Видео уже в очереди',
  notEmbeddableVideo: 'Автор ограничил показ этого видео',
  badWordsVideo: 'Видео заблокировано фильтром',
  tooLongVideo: 'Видео слишком длинное',
  tooShortVideo: 'Видео слишком короткое',
  notEnoughViewsVideo: 'У видео недостаточно просмотров',
  invalidUrlVideo: 'Неверная ссылка на видео',
  apiErrorVideo: 'Не удалось получить информацию о видео',
  liveStreamVideo: 'Прямые трансляции не разрешены',
  embedFailedVideo: 'Видео не может быть воспроизведено',
  queueIsFull: 'Очередь заполнена',
  videoQueue: 'Очередь видео',
  queueSubtitle: 'Сейчас играет и в очереди.',
  current: 'Сейчас',
  clearAllQueue: 'Очистить все',
  queue: 'Очередь',
  end: 'Закончить',
  sfxOn: 'SFX ON',
  sfxOff: 'SFX OFF',
  skip: 'Далее',
  autoskip: 'Автоскип',
  winnerIs: 'Сегодня победил',
  noOne: 'никто',
  createdBy: 'Создано VirtualZer0',
  repeat: 'Повторить',
  home: 'На главную',
  mostKek: 'Топ КЕКА',
  mostCringe: 'Топ КРИНЖА',
  today: 'Сегодня',
  allTime: 'Все время',
  statistics: 'Статистика',
  statisticsTagline: 'Пора оценить ущерб.',
  noData: 'Нет данных',
  kekWinnerTitle: 'Сегодня вы порадовали нас кучей',
  cringeWinnerTitle: 'Сегодня вы навалили тонну',
  nothingWinnerTitle: 'Кек или Кринж? А может лучше...',
  kekWinnerName: 'КЕКОВ',
  cringeWinnerName: 'КРИНЖА',
  nothingWinnerName: 'НИЧЬЯ',
  errEmojiLoading: 'Не удалось загрузить эмоджи из',
};
